import { render } from "./HistoriqueTravauxTab.vue?vue&type=template&id=255dbdd8&scoped=true&ts=true"
import script from "./HistoriqueTravauxTab.vue?vue&type=script&lang=ts"
export * from "./HistoriqueTravauxTab.vue?vue&type=script&lang=ts"

import "./HistoriqueTravauxTab.vue?vue&type=style&index=0&id=255dbdd8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255dbdd8"]])

export default __exports__